(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvTitleBarButton', drvTitleBarButton);

    drvTitleBarButton.$inject = [];

    /**
     * @ngdoc directive
     * @name drvTitleBarButton
     * 
     * @description
     * Creates a title bar button.
     * To be used with drvTitleBar.
     *
     * # Scope Properties
     * {string} text - Text to be shown for the button. Optional.
     * {string} icon - Icon to be shown for the button. Optional.
     * {string} iconColour - Icon colour to be used for the Icon. Optional.
     * {string} caption - Caption to be shown for the button. Optional.
     * {function} onClick - Function to be invoked when the button is clicked. Optional.
     * {bool} disabled - Disables the button. Optional.
     */
    function drvTitleBarButton() {
        var directive = {
            restrict: 'E',
            scope: {
                text: '<?',
                icon: '<?',
                iconColour: '<?',
                caption: '<?',
                onClick: '&?',
                disabled: '<?'
            },
            template:
                '<div class="title-bar-button">' +
                '   <md-button class="md-raised"' +
                '              ng-click="onClick()"' +
                '              ng-disabled="disabled"' +
                '              style="min-height: 24px !important; line-height: 24px !important; margin: 2px !important; text-transform: none;">' +
                '      <div drv-tool-tip="caption">' +
                '           <drv-icon ng-if="icon" icon="icon" colour="iconColour"></drv-icon>' +
                '           {{text}}' +
                '      </div>' +
                '   </md-button>' +
                '</div>'
        };
        return directive;
    }
})();